/**
 * Single place that ties frontend routes to permission resources.
 * The resource keys match backend/models/Role.js (RESOURCES).
 * To add a module: add it here, in App.js (route) and Sidebar.js (menu item).
 */
export const ROUTE_RESOURCES = [
  { path: '/dashboard', resource: 'dashboard' },
  { path: '/orders', resource: 'orders' },
  { path: '/restaurants', resource: 'restaurants' },
  { path: '/users', resource: 'users' },
  { path: '/delivery-agents', resource: 'delivery_agents' },
  { path: '/agent-locations', resource: 'agent_locations' },
  { path: '/transactions', resource: 'transactions' },
  { path: '/zones', resource: 'zones' },
  { path: '/categories', resource: 'categories' },
  { path: '/banners', resource: 'banners' },
  { path: '/explore-more', resource: 'explore_more' },
  { path: '/offers', resource: 'offers' },
  { path: '/commission-management', resource: 'commissions' },
  { path: '/affiliate-system', resource: 'affiliate' },
  { path: '/refer-earn', resource: 'referrals' },
  { path: '/reviews', resource: 'reviews' },
  { path: '/notifications', resource: 'notifications' },
  { path: '/app-icon', resource: 'app_icons' },
  { path: '/launch-screen', resource: 'launch_screen' },
  { path: '/settings', resource: 'settings' },
  { path: '/roles', resource: 'roles' },
  { path: '/admins', resource: 'admins' }
];

/** Evaluate a permission against an admin object returned by /auth/me. */
export const adminCan = (admin, resource, action = 'view') => {
  if (!admin || admin.roleDisabled) return false;
  if (admin.isSuperAdmin) return true;
  return !!admin.permissions?.[resource]?.[action];
};

/** First page this admin is allowed to open (used for the default redirect). */
export const firstAllowedPath = (admin) => {
  const hit = ROUTE_RESOURCES.find((r) => adminCan(admin, r.resource, 'view'));
  return hit ? hit.path : null;
};
